// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dy-a";
export var fulfillmentFormRail = "_dy-9";
export var headerTitleRow = "_dy-c";
export var orderDetailsWrapper = "_dy-7";
export var orderLinkTrigger = "_dy-2";
export var paymentInformationGrid = "_dy-h";
export var paymentSummaryColumn = "_dy-i";
export var shipmentContainer = "_dy-b";
export var shipmentDetailsMainPane = "_dy-8";
export var shipmentNavigationCard = "_dy-5";
export var shipmentNavigationRail = "_dy-3";
export var shipmentNavigationRailHeader = "_dy-4";
export var shipmentSummaryFact = "_dy-e";
export var shipmentSummaryGrid = "_dy-d";
export var shipmentSummaryMetadataRow = "_dy-f";
export var shipmentSummaryTags = "_dy-g";
export var shipmentWorkspace = "_dy-0";
export var shipmentWorkspaceContent = "_dy-6";
export var shipmentWorkspaceHeader = "_dy-1";